<template>
  <div class="flex flex-wrap w-full" :class="{ 'px-4 md:px-6': padding }">
    <div
      class="lg:ml-auto lg:mr-auto"
      :class="[
        containerWidth,
        { 'xl:max-w-[864px] 3xl:max-w-[1150px]': containerMaxWidth },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  containerWidth: {
    type: String,
    default: "w-full lg:w-12/14 3xl:w-12/16",
  },
  padding: {
    type: Boolean,
    default: true,
  },
  containerMaxWidth: {
    type: Boolean,
    default: false,
  },
});
</script>
